import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import { Backend } from "../services/Backend";
import Loader from "../components/Loader";

export default function AdminAppPages() {
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    const goToEditPage = (e, keyName) => {
      e.preventDefault();
      e.stopPropagation();

      navigate(`/dashboard/edit-page/${keyName}`);
    }

    return <div>
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                <TableRow className="bg-slate-950">
                    <TableCell >Name</TableCell>
                    <TableCell width="3%"></TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow >
                        <TableCell>About us</TableCell>
                        <TableCell><EditIcon className="cursor-pointer" onClick={(e) => goToEditPage(e, "about-us")}/></TableCell>
                    </TableRow>
                    <TableRow >
                        <TableCell>Disclaimer </TableCell>
                        <TableCell><EditIcon className="cursor-pointer" onClick={(e) => goToEditPage(e, "disclaimer ")}/></TableCell>
                    </TableRow>
                    <TableRow >
                        <TableCell>Privacy</TableCell>
                        <TableCell><EditIcon className="cursor-pointer" onClick={(e) => goToEditPage(e, "privacy")}/></TableCell>
                    </TableRow>
                    <TableRow >
                        <TableCell>Conditions</TableCell>
                        <TableCell><EditIcon className="cursor-pointer" onClick={(e) => goToEditPage(e, "conditions")}/></TableCell>
                    </TableRow>

                </TableBody>
            </Table>
        </TableContainer>
    </div>
}